import React from "react";
import Navbar from "../../Components/Navbar";
import Banner from "../../Components/Banner/Banner";
import Footer from "../../Components/Footer/Footer";
import Numbers from "../../Components/NumbersSection/Numbers";
import Services from "../../Components/Services/Services";
import AboutUs from "../../Components/AboutUs/AboutUs";
import Contact from "../../Components/ContactUs/Contact";
import FAQ from "../../Components/FAQ/FAQ";
import Portfolio from "../../Components/Portfolio/Portfolio";
import ViewsChart from "../../Components/LineChart/ViewsChart";
import Offers2 from "../../Components/OffersTest/Offers";
import 'swiper/swiper-bundle.min.css';
import ReviewsCarousel from "../../Components/Reviews/Reviews";
import WhyChooseUs from "../../Components/WhyUs/WhyChooseUs";




const Home = () => {
  return (
    <>
      <Navbar />
      <section id="home">
        <Banner />
      </section>
      <section id="numbers">
        <Numbers />
      </section>
      <section id="services">
      <Services />
    </section>
    <WhyChooseUs />
   <ReviewsCarousel />
 
      <Offers2 />
   
    <section id="portfolio">
      <Portfolio/>
    </section>
      <section id="about-us">
        <AboutUs />
      </section>
      <section id="contact-us">
        <Contact />
      </section>
      <FAQ/>
      <Footer />
    </>
  );
};

export default Home;
